/** Max trimmed length for a phone line (guards large pastes; sync with widget). */
export const WIDGET_PHONE_MAX_CHARS = 32;

const MIN_DIGITS = 10;
const MAX_DIGITS = 15;
/** Digits, spaces, + ( ) and hyphen only; rejects letters, newlines, symbols, and long prose. */
const ALLOWED = /^[+()0-9 -]+$/;

/**
 * @returns `null` if valid, else user-facing error (must match v1 `validateWidgetPhone` copy).
 */
export function validateWidgetPhone(text: string): string | null {
    const s = text.trim();
    if (!s) return 'Please enter a valid phone number.';
    if (s.length > WIDGET_PHONE_MAX_CHARS) {
        return 'Please enter a valid phone number.';
    }
    if (!ALLOWED.test(s)) {
        return 'Please enter a valid phone number (only digits, spaces, +, (, ), and - are allowed).';
    }
    const digits = s.replace(/\D/g, '');
    if (digits.length < MIN_DIGITS) {
        return 'Please enter a valid phone number (at least 10 digits).';
    }
    if (digits.length > MAX_DIGITS) {
        return 'Please enter a valid phone number (at most 15 digits).';
    }
    return null;
}
